'use strict';
var _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var PZOption = function PZOption(props) {
    var pzCheckValidColorCode = function pzCheckValidColorCode(colorCode) {
        return (/^#[0-9A-F]{6}$/i.test(colorCode) || /^#([0-9A-F]{3}){1,2}$/i.test(colorCode));
    };
    // const pzOptions = props.pzOptions;
    var options = Array.from(Object.keys(props.pzOptions), function(k) {
        return props.pzOptions[k];
    });
    var pzOptions = options.sort(function(a, b) {
        if (a.promize_attribute_value) {
            return a.promize_attribute_value.sort_id - b.promize_attribute_value.sort_id;
        }
    });
    var pzDisplayStyle = {
        1: 'square',
        2: 'circle',
        3: 'radio',
        4: 'checkbox',
        5: 'select',
        6: 'input'
    };
    //
    var pzTabData = props.pzSubTab ? props.pzSubTab : props.pzTab;
    var pzTabStyle = pzTabData.tab_style ? JSON.parse(pzTabData.tab_style) : '';
    var displayType = pzDisplayStyle[pzTabStyle.display] ? pzDisplayStyle[pzTabStyle.display] : 'square';
    var pzOptionDesc = null;
    var pzColorPicker = null;
    var pzSelectedObjs = null;
    var pzOptionDisclaimer = null;
    if (props.pzAttribute.promize_attribute.attribute_code == "lanyard_selected_options") {
        var selectedObj = props.HomeComponent.pzGetSelectedValuesForCart(props.pzCanvasObject);
        if (selectedObj && selectedObj['cartObject']) {
            pzSelectedObjs = _extends({}, selectedObj['cartObject']);
        }
    }
    return React.createElement(
        React.Fragment,
        null,
        props.pzAttribute.promize_attribute.attribute_code != "lanyard_selected_options" && React.createElement(
            'div', {
                className: 'pz-design-item-wrapper'
            },
            pzTabStyle.enableAttrName && React.createElement(
                'p', {
                    className: 'pz-design-item-title'
                },
                props.pzAttribute.promize_attribute.attribute_name
            ),
            displayType == "select" && React.createElement(
                'button', {
                    className: 'pz-font-size'
                },
                React.createElement(
                    'span',
                    null,
                    'Sample test'
                ),
                React.createElement('i', {
                    className: 'fa fa-caret-down'
                })
            ),
            React.createElement(
                'ul', {
                    className: displayType == 'select' ? "pz-font-size-list" : "pz-design-item-list"
                },
                Object.keys(pzOptions).map(function(tabOption, option_index) {
                    var pzTabOption = pzOptions[tabOption];
                    var pzOptionValue = pzTabOption.promize_attribute_value;
                    pzColorPicker = pzOptionValue.option_code == 'colorpicker-3/4' ? pzOptionValue.option_name : pzColorPicker;
                    //pzColorPicker = (pzOptionValue.option_code == 'colorpicker-3/4') ? true : false;
                    //console.log("pzColorPickerpzColorPickerpzColorPicker ***********", pzColorPicker)
                    //const pzAttrAdditionalData = (pzOptionValue.additional_data) ? JSON.parse(pzOptionValue.additional_data) : null;
                    if (props.pzHideAttributeValues.includes(pzTabOption.promize_tab_attribute_values_id) || props.pzBaseType && pzOptionValue.option_code && !pzOptionValue.option_code.includes(props.pzBaseType)) {
                        return '';
                    }
                    if (pzTabOption && Object.keys(pzTabOption).length > 0) {
                        var pzOptionColorCode = pzOptionValue.option_value && pzOptionValue.option_value.charAt(0) == '#' && pzCheckValidColorCode(pzOptionValue.option_value) ? pzOptionValue.option_value : pzCheckValidColorCode('#' + pzOptionValue.option_value) ? '#' + pzOptionValue.option_value : '';
                        var activeClass = props.pzActiveOptions[pzTabData.promize_tab_id] && props.pzActiveOptions[pzTabData.promize_tab_id][1] == pzTabOption.promize_tab_attribute_values_id ? true : false;
                        if (activeClass && pzOptionValue.option_description) {
                            pzOptionDesc = pzOptionValue.option_description;
                            if (pzOptionValue.option_code.includes('silkscreen')) {
                                pzOptionDisclaimer = '"Please note Silkscreen allows only up to 3 color Imprints. If your imprint has more than 3 colors kindly choose Dye Sublimation printing option"';
                            } else {
                                pzOptionDisclaimer = '';
                            }
                        }
                        //pzOptionDesc[pzTabData.promize_tab_id] = ? pzOptionValue.option_description : null;
                        var pzOptionThumbImg = '';
                        if (pzOptionValue.promize_images && Object.keys(pzOptionValue.promize_images).length > 0) {
                            pzOptionThumbImg = pzOptionValue.promize_images.find(function(val) {
                                return val.image_type == "option_thubnail_image";
                            });
                        }
                        // pzOptionThumbImg = pzOptionThumbImg ? props.pzImgUrl.concat(pzOptionThumbImg.image_url) : '';
                        pzOptionThumbImg = pzOptionThumbImg ? props.pzImgUrl.concat(pzOptionThumbImg.image_url.replace(props.pzReplaceImg, '')) : '';
                        var style = {
                            background: 'url(' + pzOptionThumbImg + ') ' + (!pzOptionThumbImg ? pzOptionColorCode : 'white') + ' ',
                            width: pzTabStyle && pzTabStyle.width > 0 ? pzTabStyle.width : '40',
                            height: pzTabStyle && pzTabStyle.height > 0 ? pzTabStyle.height : '40',
                            borderRadius: pzDisplayStyle[pzTabStyle.display] == 'circle' ? '50%' : ''
                        };
                        if (displayType == "circle" || displayType == "square") {
                            var pzHoverText = pzOptionValue.option_name;
                            //let pzHoverText = (pzOptionValue.option_description) ? pzOptionValue.option_description : pzOptionValue.option_name;
                            return React.createElement(
                                'li', {
                                    key: pzOptionValue.option_id,
                                    className: 'pz-design-item ' + (pzOptionValue.option_code == 'colorpicker-3/4' ? ' hide ' : '') + ' ' + (activeClass ? 'active' : ''),
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        props.clickHandler(pzTabOption, '', '', e);
                                    },
                                    onMouseOver: function onMouseOver(e) {
                                        e.preventDefault();
                                        props.mouseHoverHandler(pzHoverText, e);
                                    },
                                    onMouseOut: function onMouseOut(e) {
                                        props.mouseHoverHandler('', e);
                                    }
                                },
                                React.createElement(
                                    'div', {
                                        className: 'pz-design-item-content'
                                    },
                                    React.createElement('div', {
                                        className: 'pz-design-item-img ' + (pzOptionThumbImg ? 'pz-image' : ''),
                                        style: style
                                    }),
                                    React.createElement(
                                        'div', {
                                            className: 'pz-design-item-name'
                                        },
                                        pzOptionValue.option_name,
                                        ' ',
                                        pzTabOption.promize_tab_attribute_values_id
                                    ),
                                    pzOptionValue.option_price && React.createElement(
                                        'div', {
                                            className: 'pz-design-item-price'
                                        },
                                        React.createElement(
                                            'span',
                                            null,
                                            '$',
                                            pzOptionValue.option_price
                                        )
                                    )
                                )
                            );
                        } else if (displayType == "checkbox" || displayType == "radio" || displayType == "input" || displayType == "select") {
                            var checked = props.showCopyPopup ? 'checked' : '';
                            var filedTypeName = displayType != "radio" ? pzOptionValue.option_name : 'radio';
                            return React.createElement(
                                'li', {
                                    key: pzOptionValue.option_id,
                                    className: 'pz-design-item'
                                },
                                React.createElement(
                                    'div', {
                                        className: 'pz-design-item-content'
                                    },
                                    React.createElement('input', {
                                        style: style,
                                        type: displayType,
                                        name: filedTypeName,
                                        checked: checked,
                                        onClick: function onClick(e) {
                                            props.clickHandler(pzTabOption, '', '', e);
                                        }
                                    }),
                                    React.createElement(
                                        'span', {
                                            className: 'pz-design-item-name'
                                        },
                                        pzOptionValue.option_name
                                    ),
                                    pzOptionValue.option_price && React.createElement(
                                        'div', {
                                            className: 'pz-design-item-price'
                                        },
                                        React.createElement(
                                            'span',
                                            null,
                                            '$',
                                            pzOptionValue.option_price
                                        )
                                    )
                                )
                            );
                        }
                        // TODO work on select
                        else if (displayType == "select") {
                            return React.createElement(
                                'option', {
                                    onClick: function onClick() {
                                        props.clickHandler(pzTabOption);
                                    },
                                    className: 'pz-design-item'
                                },
                                pzOptionValue.option_name
                            );
                        }
                    }
                })
            ),
            pzColorPicker && React.createElement(
                'div', {
                    className: 'pz-text-color-picker',
                    onMouseOver: function onMouseOver(e) {
                        e.preventDefault();
                        props.mouseHoverHandler(pzColorPicker, e);
                    },
                    onMouseOut: function onMouseOut(e) {
                        props.mouseHoverHandler('', e);
                    }
                },
                React.createElement(
                    'label', {
                        htmlFor: 'pz-text-font'
                    },
                    'Color Picker'
                ),
                React.createElement(
                    'div', {
                        className: 'pz-clr-wrapper'
                    },
                    React.createElement(
                        'div', {
                            className: 'pz-clr-pciker'
                        },
                        React.createElement(JsColor, _extends({}, props, {
                            className: 'pzcolorpicker',
                            id: 'pzcolorpicker',
                            onChange: function onChange(e, selected) {
                                props.pzOptionColor(e, selected, pzOptions[Object.keys(pzOptions)[0]]);
                            }
                        }))
                    )
                )
            ),
            pzOptionDesc && React.createElement('div', {
                'class': "pz-design-item-desc",
                dangerouslySetInnerHTML: {
                    __html: pzOptionDesc
                }
            }) //,
            //pzOptionDisclaimer && React.createElement('div', { 'class': "pz-design-item-disclaimer", dangerouslySetInnerHTML: { __html: pzOptionDisclaimer } })
        ),
        pzSelectedObjs && Object.keys(pzSelectedObjs).length > 0 && React.createElement(
            'div', {
                className: 'pz-selected-option-inner-container'
            },
            Object.keys(pzSelectedObjs).map(function(objKey, objIdx) {
                if (objKey != "bulk_pricing") {
                    var image = pzSelectedObjs[objKey];
                    if (objKey.includes('IMAGE') && !objKey.toLowerCase().includes("front text and image") && !objKey.toLowerCase().includes("space")) {
                        image = React.createElement(
                            'a', {
                                href: image,
                                target: '_blank'
                            },
                            objKey
                        );
                    }
                    return React.createElement(
                        'div', {
                            className: 'pz-selected-option'
                        },
                        React.createElement(
                            'span', {
                                className: 'selected-opt-title'
                            },
                            objKey
                        ),
                        React.createElement(
                            'span', {
                                className: 'selected-opt-value'
                            },
                            image
                        ),
                        ' '
                    );
                }
            })
        )
    );
};
